export default __webpack_public_path__ + "static/media/AutomaticIcon.5391a4ad.svg";